import { render, staticRenderFns } from "./team-images.vue?vue&type=template&id=d12955aa&scoped=true&"
import script from "./team-images.vue?vue&type=script&lang=js&"
export * from "./team-images.vue?vue&type=script&lang=js&"
import style0 from "./team-images.vue?vue&type=style&index=0&id=d12955aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12955aa",
  null
  
)

export default component.exports